import { Link } from "react-router-dom";

export type CreateMode = "video" | "image";

/**
 * The persistent Video / Image mode indicator shown above each creation
 * flow, so the user always sees which mode they are in (and can switch). It
 * is rendered by the router around the existing Video flow — the Video
 * `CreateTab` itself is not modified.
 */
export function CreateModeBar({ mode }: { readonly mode: CreateMode }) {
  return (
    <div className="mode-bar" data-testid="create-mode-bar" role="navigation" aria-label="Creation mode">
      <span className="mode-bar-current" data-testid="create-mode-current">
        You are in {mode === "video" ? "Video" : "Image"} mode
      </span>
      <span className="mode-bar-switch">
        <Link to="/generate/create/video" className={mode === "video" ? "active" : ""} aria-current={mode === "video" ? "page" : undefined}>
          VIDEO
        </Link>
        <Link to="/generate/create/image" className={mode === "image" ? "active" : ""} aria-current={mode === "image" ? "page" : undefined}>
          IMAGE
        </Link>
      </span>
    </div>
  );
}
